<div class="reference_body">
  <main class="reference_main">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">
      <div class="reference_table">

        <div class="container ">
          <div class="row mt-5">
            <div class="col-md-4">
              <h3>GMOU Header Information</h3>
            </div>
          </div>
          <form [formGroup]="gmouForm" >
            <div class="row mt-5">


              <div class="col-md-4">

                <mat-form-field class="full-width-field" id="id_number">
                  <input matInput placeholder="Enter GMOU Title" formControlName="GMOUTitle"  >

                  <mat-error *ngIf="errorHandling('GMOUTitle', 'required')">
                     You must provide <strong>GMOU title</strong>
                  </mat-error>
               </mat-form-field>

               </div>


              <div class="col-md-4">
                <mat-form-field class="full-width-field" id="id_number">
                  <mat-label>Select Project Type</mat-label>
                  <mat-select formControlName="GMOUTypeId">
                    <mat-option>-- None --</mat-option>
                    <mat-optgroup *ngFor="let projectCategory of projectCategories" [label]="projectCategory.ProjectCategoryName"
                                  >
                      <mat-option *ngFor="let projectType of projectCategory.projectTypes" [value]="projectType.id">
                        {{projectType.ProjectTypeName}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>

                  <mat-error *ngIf="errorHandling('GMOUTypeId', 'required')">
                    You must provide <strong>project type</strong>
                 </mat-error>

                </mat-form-field>
               </div>

              <div class="col-md-4">
                <mat-form-field class="full-width-field" id="id_number">

       <input matInput [matDatepicker]="picker" formControlName="NegotiationDate" placeholder="Select negotiation date">
       <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
       <mat-datepicker #picker></mat-datepicker>
       <mat-hint></mat-hint>

                  <mat-error *ngIf="errorHandling('NegotiationDate', 'required')">
                     You must provide <strong>negotiation date</strong>
                  </mat-error>
               </mat-form-field>

              </div>

            </div>
            <div class="row mt-4">
              <div class="col-md-4">
                <mat-form-field class="full-width-field" id="id_number">

              <input matInput [matDatepicker]="picker1" formControlName="SignatureDate" placeholder="Select signature date">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
              <mat-hint></mat-hint>

                  <mat-error *ngIf="errorHandling('SignatureDate', 'required')">
                     You must provide <strong>signature date</strong>
                  </mat-error>
               </mat-form-field>

              </div>

              <div class="col-md-4">
                <mat-form-field class="full-width-field" id="id_number">
                  <mat-label *ngIf="genericLabel">Select {{genericLabel}}</mat-label>
                  <mat-select [formControl]="oilfieldsFormCtrl" (selectionChange)="onClickOilField($event.value)" multiple>
                    <mat-option>-- None --</mat-option>
                    <mat-select-trigger>
                      {{oilfieldsFormCtrl.value ? oilfieldsFormCtrl.value[0].LgaName : ''}}
                      <span *ngIf="oilfieldsFormCtrl.value?.length > 1" class="example-additional-selection">
                        (+{{oilfieldsFormCtrl.value.length - 1}} {{oilfieldsFormCtrl.value?.length === 2 ? 'other' : 'others'}})
                      </span>
                    </mat-select-trigger>
                    <mat-optgroup *ngFor="let oilBlock of oilBlocks" [label]="oilBlock.OilBlockName"
                                  >
                      <mat-option *ngFor="let oilField of oilBlock.oilFields" [value]="oilField">
                        {{oilField.OilFieldName}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>

                  <mat-error *ngIf="errorHandling('OilFieldId', 'required')">
                    You must provide <strong>oil field</strong>
                 </mat-error>
                </mat-form-field>
               </div>


               <!-- <mat-form-field>
                <mat-label>Toppings</mat-label>
                <mat-select [formControl]="toppings" (selectionChange)="onClick($event.value)" multiple>
                  <mat-select-trigger>
                    {{toppings.value ? toppings.value[0] : ''}}
                    <span *ngIf="toppings.value?.length > 1" class="example-additional-selection">
                      (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
                    </span>
                  </mat-select-trigger>
                  <mat-option *ngFor="let topping of toppingList" [value]="topping">{{topping}}</mat-option>
                </mat-select>
              </mat-form-field> -->

              <div class="col-md-4">
                <mat-form-field class="full-width-field" id="id_number">
                  <mat-label>Select LGA</mat-label>
                  <mat-select [formControl]="toppings" (selectionChange)="onClick($event.value)" multiple>
                    <mat-option>-- None --</mat-option>
                    <mat-select-trigger>
                      {{toppings.value ? toppings.value[0].LgaName : ''}}
                      <span *ngIf="toppings.value?.length > 1" class="example-additional-selection">
                        (+{{toppings.value.length - 1}} {{toppings.value?.length === 2 ? 'other' : 'others'}})
                      </span>
                    </mat-select-trigger>
                    <mat-optgroup *ngFor="let state of states" [label]="state.StateName">


                      <mat-option *ngFor="let lga of state.lgas" [value]="lga">
                        {{lga.LgaName}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-select>

                  <mat-error *ngIf="errorHandling('LGAId', 'required')">
                    You must provide <strong>LGA</strong>
                 </mat-error>
                </mat-form-field>
               </div>



            </div>

            <div class="row mt-4">
              <div class="col-md-12">

                <mat-form-field class="full-width-field" id="id_number">
                  <textarea matInput placeholder="Enter GMOU Description" rows="5" formControlName="GMOUDescription"  ></textarea>

                  <mat-error *ngIf="errorHandling('GMOUDescription', 'required')">
                     You must provide <strong>GMOU Description</strong>
                  </mat-error>
               </mat-form-field>

               </div>

               <div class="submit">

                <button type="submit" (click)="onSubmit(gmouForm.value)" [disabled]="gmouForm.invalid"  class="submit_button" type="submit">Submit</button>


               </div>
            </div>
          </form>

        </div>

      </div>

      </div>

  </main>
</div>
